var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownX2 = function SvgDownX2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.646 13.354a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0-.708-.708L8 12.293 4.354 8.646a.5.5 0 1 0-.708.708zM8 7.5a.5.5 0 0 0 .354-.146l4-4a.5.5 0 0 0-.708-.708L8 6.293 4.354 2.646a.5.5 0 1 0-.708.708l4 4A.5.5 0 0 0 8 7.5",
    clipRule: "evenodd"
  })));
};
export { SvgDownX2 as ReactComponent };
export default __webpack_public_path__ + "c5101ff17f56770d476dd303372ab661.svg";